import { StyledSelect, StyledOption } from "./RoleSelect.styled";
import AccountBannerImage from "../../assets/images/account-banner.png"
import ProfileImage from "../../assets/images/profile-icon.png"
import { useEffect, useState } from "react";

interface Props {
    id: string
    role: string
    handleChangeRole: (id: string, role: string) => void
}

export const RoleSelect = (props: Props) => {
    const [selectedRole, setSelectedRole] = useState<string>(props.role)
    const handleChange = (value: string) => {
        setSelectedRole(value);
        props.handleChangeRole(props.id, value);
    }

    useEffect(() => {
        setSelectedRole(props.role);
    }, [props])
    return (
        <StyledSelect value={selectedRole} onChange={(e) => handleChange(e.target.value)} className={`${selectedRole == "1" ? "super" : selectedRole == "2" ? "partner" : ""}`}>
            <StyledOption value={1}>Super Admin</StyledOption>
            <StyledOption value={2}>Partner</StyledOption>
            <StyledOption value={3}>Player</StyledOption>
        </StyledSelect>
    );
};